import { useDispatch, useSelector } from 'react-redux';
import useSystemSettingForm from '../../hooks/useSystemSettingForm ';
import { clearEditSetting, updateSetting } from '../../redux/actions/clients';
import { StoreState } from '../../types/state';
import EditDialog from '../Common/EditDialog';

const EditSetting = () => {
  const { clientId, setting } = useSelector(
    (state: StoreState) => state.clients.editSetting
  );
  const { settingSchema } = useSystemSettingForm(setting);
  const dispatch = useDispatch();

  if (!setting) return null;

  const handleUpdate = (data: any) => {
    dispatch(updateSetting(data, clientId));
  };

  return (
    <EditDialog
      update={handleUpdate}
      onClose={() => dispatch(clearEditSetting())}
      formSchema={settingSchema}
      formData={setting}
    />
  );
};
export default EditSetting;
